// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"FilterSearch_inputSearch__1Gks7"};